// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__hgGDm","range":"MonthRangeSwitch_range__tXsMj","disabled":"MonthRangeSwitch_disabled__1HQy1"};